<!-- Zweck: Stellt die HTML-Struktur für shop artikel status icon component im Frontend bereit. -->


<span class="dot {{color}}{{showTooltip ? ' helpcursor':''}}" style="vertical-align: middle"
matTooltip="{{showTooltip ? VerfuegbarkeitsstatusText:null}}">
  @if (icon) {
    <svg-icon [style.color]="iconColor">{{icon}}</svg-icon>
  }
</span>

@if (artikel.bestandSum !== undefined) {
  <div class="lginfo" [class.hasMore]="artikel.bestand">
    {{artikel.bestandSum}} Stk.
    @if (artikel.bestand) {
      <div class="lgdetails mat-elevation-z1">
        <div class="header">Lagerstände</div>
        <table>
          @for (bs of artikel.bestand; track bs) {
            <tr>
              <td>
                {{bs.Betriebsstaette.Bezeichnung}}
              </td>
              <td style="text-align: right">
                {{bs.VBestand}} Stk.
              </td>
            </tr>
          }
        </table>
      </div>
    }
  </div>
}
